import React from "react";
import { MailBuilder } from "mail-builder-package";
import TemplatesStore from "../../../stores/templatesStore";
import { TemplateModel } from "../../../stores/TemplateModel";
import { observable, action } from "mobx";
import { observer, inject } from "mobx-react";
import { withRouter, RouteComponentProps } from "react-router-dom";

interface IBuilderPageProps extends RouteComponentProps<any>{
  templatesStore?: TemplatesStore;
}

@inject("templatesStore")
@observer
class BuilderPage extends React.PureComponent<IBuilderPageProps, any> {
  @observable template: TemplateModel | null = null;

  @action setTemplate = (template: TemplateModel) => {
    this.template = template;
  };

  onSave = async (json: any,html:string,templateDataUrl:any) => {
    this.template!.json = json;
    this.template!.html = html;
    this.template!.templateDataUrl = templateDataUrl;
    await this.template!.save();
  };

  getTemplate = async () => {
    const { templatesStore } = this.props;

    let template = await templatesStore!.getTemplate(this.props.match.params.id);

    if (!template) {
      //viewStore.showView("templates");
      return;
    }
    this.setTemplate(template);
  };

  componentDidMount = () => {
    this.getTemplate();
  };

  render() {
    return this.template === null ? null : (
      <MailBuilder
        template={this.template?.json}
        onSave={this.onSave}
        closeEditor={() => this.props.history.push("/templates")}
      />
    );
  }
}

export default withRouter(BuilderPage);
